"use strict";

/* globals app, socket, ajaxify */

(function() {
	$(window).on('action:topic.tools.load', function(event, data) {
		$('.thread-tools .connect-homepage-main-topic').on('click', function() {
			socket.emit(
				'plugins.connectHomepage.homepage.setMainTopic',
				{
					tid: ajaxify.data.tid,
					cid: ajaxify.data.cid
				},
				function(err, returnData) {
					if(err) {
						app.alertError(returnData);
						return;
					}
					app.alertSuccess(returnData.message);
				}
			);
		});
	});
}());